import { Edit, EditBase, ShowButton, useRecordContext } from "react-admin";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ComponentEdit from "../../../components/PageComponents/ComponentEdit";
import ProjectForm from "./ProjectForm";
import { FETCH_ENTITY } from "./projectFields";

const Content = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <ComponentEdit title="Edit entity" subtitle={record.name || ""} actions={<ShowButton icon={<VisibilityOutlinedIcon />} />}>
      <Edit redirect="show" actions={false} sx={{ "& .RaEdit-card": { overflow: "visible" } }}>
        <ProjectForm />
      </Edit>
    </ComponentEdit>
  );
};

const ProjectEdit = () => (
  <EditBase queryOptions={FETCH_ENTITY}>
    <Content />
  </EditBase>
);

export default ProjectEdit;
